module.exports = __webpack_public_path__ + "static/media/chinese_text_analyze_demo.71583e79.png";